// frontend/src/components/Sidebar/Sidebar.jsx
//
// Navigation sidebar.
// Reads MODULE_ROUTES from router.jsx — adding a new module there
// automatically adds it to the sidebar without touching this component.
//
// useLocation + NavLink provide active-route highlighting.
// The avatar/name block at the top is intentionally empty — fill it
// when adding personal data.

import { NavLink, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { MODULE_ROUTES } from '../../router'
import styles from './Sidebar.module.css'

export default function Sidebar() {
  const { t, i18n } = useTranslation()
  // Filter to only routes that should appear in the sidebar
  const navRoutes = MODULE_ROUTES.filter((r) => r.showInSidebar)

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang)
    localStorage.setItem('portal_lang', lang)
  }

  return (
    <aside className={styles.sidebar}>

      {/* ── Identity block ────────────────────────────────────────────────── */}
      {/* TODO: fill name, title, and avatar src when adding personal data */}
      <div className={styles.identity}>
        <div className={styles.avatarPlaceholder} aria-hidden="true">
          {/* TODO: replace with <img src="..." alt="..." /> */}
        </div>
        <div className={styles.identityText}>
          <p className={styles.name}>
            {/* TODO: your name here */}
          </p>
          <p className={styles.title}>
            {/* TODO: your job title here */}
          </p>
        </div>
      </div>

      {/* ── Navigation ────────────────────────────────────────────────────── */}
      <nav className={styles.nav} aria-label={t('nav.main_label')}>
        <ul className={styles.navList}>
          {navRoutes.map(({ path, labelKey }) => (
            <li key={path} className={styles.navItem}>
              <NavLink
                to={path}
                end={path === '/'}
                className={({ isActive }) =>
                  [styles.navLink, isActive ? styles.navLinkActive : ''].join(' ').trim()
                }
              >
                {t(labelKey)}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* ── Footer / social links ─────────────────────────────────────────── */}
      {/* TODO: add social links when adding personal data */}
      <div className={styles.sidebarFooter}>
        {/* <a href="https://github.com/..." target="_blank" rel="noopener noreferrer">GitHub</a> */}
        {/* <a href="https://t.me/..."    target="_blank" rel="noopener noreferrer">Telegram</a> */}
        {/* <a href="mailto:..."                                                    >Email</a> */}
      </div>

      {/* ── Language switcher ─────────────────────────────────────────────── */}
      <div className={styles.langSwitcher}>
        <button
          className={`${styles.langBtn} ${i18n.language.startsWith('ru') ? styles.langBtnActive : ''}`}
          onClick={() => changeLanguage('ru')}
          aria-label="Переключить на русский язык"
          aria-pressed={i18n.language.startsWith('ru')}
        >
          RU
        </button>
        <span className={styles.langSep} aria-hidden="true">|</span>
        <button
          className={`${styles.langBtn} ${i18n.language.startsWith('en') ? styles.langBtnActive : ''}`}
          onClick={() => changeLanguage('en')}
          aria-label="Switch to English"
          aria-pressed={i18n.language.startsWith('en')}
        >
          EN
        </button>
      </div>

    </aside>
  )
}
